import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetActivatedAt($id: ID!) {
    user(id: $id) {
      uuid
      activatedAt
    }
  }
`

export const getActivatedAtKey = getQueryNames(query)[0]

export default query
